import { render, staticRenderFns } from "./gFab.vue?vue&type=template&id=07f00220&"
import script from "./gFab.vue?vue&type=script&lang=js&"
export * from "./gFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gFab.vue"
export default component.exports